export default "__VITE_ASSET__zhR$vLX3__"